import { useRouter } from "next/navigation";

export const useRoutes = () => {
  const router = useRouter();

  const getQueries = (queries: Record<string, string>) => {
    const params = new URLSearchParams(window.location.search);
    Object.entries(queries).forEach(([k, v]) => params.set(k, v));
    return params.toString();
  };

  const replace = ({
    url,
    queries,
  }: {
    url: string;
    queries?: Record<string, string>;
  }) => {
    const queriesStr = queries ? `?${getQueries(queries)}}` : "";
    return router.replace(`${url}${queriesStr}`);
  };

  return { replace };
};
